import * as z from 'zod';

import { OptimizelyResults, OptimizelyUserAttributes } from './experiments.ts';

/**
 * Allowed Optimizely event keys. Adding a new event type requires updating
 * this enum — this is intentional to prevent arbitrary keys polluting results.
 */
export const OptimizelyEventKey = z.enum([
  'page_views',
  'form_submits',
  'add_to_carts',
  'click_engagements',
  'rate_selection',
]);
export type OptimizelyEventKey = z.infer<typeof OptimizelyEventKey>;

/**
 * Zod schema for the POST /api/optimizely/events request body.
 * Extracted into a standalone module so it can be imported in tests
 * without triggering Next.js server-side imports.
 */
export const EventBodySchema = z.object({
  eventKey: OptimizelyEventKey,
  url: z.string().optional(),
  properties: z.record(z.string(), z.string()).default({}),
  revenue: z.number().optional(),
  value: z.number().optional(),
});

export const OptimizelyImpressionResponse = z.object({
  uid: z.string().optional().nullable(),
  userAttributes: OptimizelyUserAttributes.optional().nullable(),
  results: OptimizelyResults.optional().nullable(),
});
export type OptimizelyImpressionResponse = z.infer<
  typeof OptimizelyImpressionResponse
>;
